import {
  DataProvider,
  GetListParams,
  GetManyParams,
  GetOneParams,
} from 'react-admin';
import { httpClient } from '../httpClient';

const transformData = (reportedEvent: any) => {
  return reportedEvent.reports;
};

/**
 * params:
 {
    filter: {}
    meta: undefined
    pagination: {page: 1, perPage: 10}
    sort: {field: 'id', order: 'ASC'}
  }
  */
const fetchReportedEventsList = async (
  params: GetListParams | GetManyParams | GetOneParams,
) => {
  const query = new URLSearchParams(
    (params as GetListParams).pagination
      ? {
          limit: String((params as GetListParams).pagination.perPage),
          offset: String(
            ((params as GetListParams).pagination.page - 1) *
              (params as GetListParams).pagination.perPage,
          ),
        }
      : {},
  ).toString();
  const reportedEventsList = await httpClient(`/admin/event/reported?${query}`, {
    method: 'GET',
    ...params,
  });

  return reportedEventsList.json.flatMap(transformData) as any[];
};

// @ts-expect-error not yet all functions
export const eventReportsProvider: DataProvider = {
  // getList: async (resource, params) => {
  //   const reportedEventsList = await fetchReportedEventsList(params);

  //   return {
  //     data: reportedEventsList,
  //     // TODO: needs to come from the server
  //     total: reportedEventsList.length,
  //   };
  // },
  // getMany: async (resource, params) => {
  //   const reportedEventsList = await fetchReportedEventsList(params);

  //   return {
  //     data: reportedEventsList,
  //     // TODO: needs to come from the server
  //     total: reportedEventsList.length,
  //   };
  // },
  getManyReference: async (resource, params) => {
    const reportedEventsList = await fetchReportedEventsList(params);
    const filteredData = reportedEventsList.filter((report) => report.eventId === params.id);

    console.log('filteredData', filteredData);

    return {
      data: filteredData,
      // TODO: needs to come from the server
      total: filteredData.length,
    };
  },
  // getOne: async (resource, params) => {
  //   const reportedEventsList = await fetchReportedEventsList(params);

  //   return {
  //     data: reportedEventsList.find((item) => item.id === params.id),
  //   };
  // },
};
